export default "__VITE_ASSET__BIP0bGkd__"